<template>
  <v-app id="inspire" class="bodyPadding"> 
    <mo-header></mo-header>
    <v-content>
		<pc-head></pc-head>		
		<pc-list></pc-list>
    </v-content>
  </v-app>
</template>

<script>

	import PcHead from './Header.vue';	
	import PcList from './List.vue';
	export default {
		data () {
			return {
		
			}		
		},
		components: {
          PcHead,			
          PcList
		}
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>